import React from 'react'

const About = () => {
  return (
    <main>
        <h2>About</h2>
        <p style={{marginTop:"1rem"}}> this 
        blog app is a project about tutuorial
        </p>
    </main>  
  )
}

export default About